module.exports = __webpack_public_path__ + "static/banner-474991cb9dc6be41cdd5f13deb654120.png";